import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'appkit-react';
import debounce from 'lodash/debounce';

// import '@style/components/actionButtonsGroup.scss';
import '../styles/components/actionButtonsGroup.scss';

function isInViewport(element, bottomOffset) {
  if (!element) {
    return false;
  }
  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 40 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) +
        bottomOffset
  );
}

export const SaveAndCancelBtns = ({
  handleBack,
  handleSave,
  bottomOffset = 0,
}) => {
  const ref = useRef(null);
  const [inView, enteredView] = useState(true);

  const toggleInView = debounce((v) => enteredView(v), 200);

  const checkIsElemInView = function (e) {
    const isElemInView = isInViewport(ref.current, bottomOffset);
    if (isElemInView) {
      toggleInView(true);
    } else {
      toggleInView(false);
    }
  };

  useEffect(() => {
    if (ref.current) {
      checkIsElemInView();
    }
  }, [ref.current]);

  useEffect(() => {
    if (!ref?.current) {
      return () => {};
    }

    window.addEventListener('scroll', checkIsElemInView);

    return () => window.removeEventListener('scroll', checkIsElemInView);
  }, [ref, toggleInView]);

  return (
    <>
      <span ref={ref} />
      <div className={inView ? '' : 'save-and-cancel-fixed'}>
        <Button
          className="cancel-btn"
          kind="secondary"
          size="lg"
          onClick={handleBack}
        >
          {inView ? 'Cancel' : <span className="appkiticon icon-close-fill" />}
        </Button>
        <Button
          className="save-btn"
          kind="primary"
          size="lg"
          onClick={handleSave}
        >
          {inView ? 'Save' : <span className="appkiticon icon-save-fill" />}
        </Button>
      </div>
    </>
  );
};
